// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import VueCal from 'vue-cal';
import 'vue-cal/dist/vuecal.css';
import 'vue-cal/dist/i18n/zh-hk.js'
import router from './router'
import 'bootstrap'
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import axios from 'axios'
import API from '../src/JSON/APIJson.json'
import { setCookie, getCookie, delCookie } from './assets/cookie.js'
import _global from '../src/Global.vue'
import './assets/global.css';

Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
Vue.config.productionTip = false
Vue.component('vue-cal', VueCal);

axios.defaults.headers.common['Cache-Control'] = 'no-catch'
Vue.prototype.$axios = axios;
Vue.prototype.$URLJson = API;
Vue.prototype.$Global = _global;
Vue.prototype.$Img = { url: '' };

Vue.prototype.$cookieFunc = {
  getCookie,
  setCookie,
  delCookie
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  watch: {
    //"$route": 'checkLogin'
  },
  created() {
    //this.checkLogin()
    //////開發
    //this.$axios.defaults.baseURL = 'https://localhost:7218/'; //開發用
    // this.$axios.defaults.baseURL = 'http://192.168.2.158/sampojulife_client_API/'; //開發用
    // this.$Img.url = 'http://192.168.2.158/sampojulife_client_img/'; //開發用
    //正式
    this.$axios.defaults.baseURL = location.protocol + '//' + location.host + '/sampojulife_client_API/';
    this.$Img.url = location.protocol + '//' + location.host + '/sampojulife_client_img/';


  },
  methods: {
    checkLogin() {
      if (this.$settimeoutStatus.Status) {
        var timeout_i = setTimeout(function () { }, 1000);
        for (var i = 1; i < 10; i++) {
          clearTimeout((Number(timeout_i) - Number(i)));
        }
      }
      var s = this.$cookieFunc.getCookie("session");
      if (this.$Global.Base64Utils.atou(s) != "session") {
        this.$router.push({
          path: '/Login'
        });
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/main.js